import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGatewayGetTransactionsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.form-validation';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { ChargePointFilterController } from '@app/feature/charge-point/charge-point-filter/charge-point-filter.controller';
import { LocationFilterController } from '@app/feature/location/location-filter/location-filter.controller';

import { TransactionCreatedAfterFilterController } from '../../transaction-created-after-filter/transaction-created-after-filter.controller';
import { TransactionCreatedBeforeFilterController } from '../../transaction-created-before-filter/transaction-created-before-filter.controller';
import { TransactionStateFilterController } from '../../transaction-state-filter/transaction-state-filter.controller';

const TransactionListFilterFormStep1CreatedAfterFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsPaginatedModel>();
    const { createdAfter } = useGatewayGetTransactionsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="createdAfter"
          control={control}
          rules={createdAfter}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <TransactionCreatedAfterFilterController
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(value) => {
                  field.onChange(value);
                }}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const TransactionListFilterFormStep1CreatedBeforeFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsPaginatedModel>();
    const { createdBefore } =
      useGatewayGetTransactionsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="createdBefore"
          control={control}
          rules={createdBefore}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <TransactionCreatedBeforeFilterController
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(value) => {
                  field.onChange(value);
                }}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const TransactionListFilterFormStep1LocationIdFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsPaginatedModel>();
    const { locationId } = useGatewayGetTransactionsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="locationId"
          control={control}
          rules={locationId}
          render={({ field /* , fieldState: { error } */ }) => {
            const values = [];

            if (Array.isArray(field.value)) {
              values.push(...field.value);
            } else if (field.value) {
              values.push(field.value);
            }

            return (
              <LocationFilterController
                selectedItemIds={values}
                onChange={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const TransactionListFilterFormStep1ChargePointIdFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsPaginatedModel>();
    const { chargePointId } =
      useGatewayGetTransactionsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="chargePointId"
          control={control}
          rules={chargePointId}
          render={({ field /* , fieldState: { error } */ }) => {
            const values = [];

            if (Array.isArray(field.value)) {
              values.push(...field.value);
            } else if (field.value) {
              values.push(field.value);
            }

            return (
              <ChargePointFilterController
                selectedItemIds={values}
                onChange={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const TransactionListFilterFormStep1CurrentStateFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsPaginatedModel>();
    const { currentState } = useGatewayGetTransactionsPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="currentState"
        control={control}
        rules={currentState}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <TransactionStateFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
    );
  };

export const TransactionListFilterFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.M}>
        <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
          <TransactionListFilterFormStep1CreatedAfterFragment />
          <TransactionListFilterFormStep1CreatedBeforeFragment />
          <TransactionListFilterFormStep1LocationIdFragment />
          <TransactionListFilterFormStep1ChargePointIdFragment />
          <TransactionListFilterFormStep1CurrentStateFragment />
        </Stack>
      </Stack>
    );
  };
